import React from 'react';

import { BaSeBoard } from '@base/react';
import { NewClassRoomContext } from '../../context/new-class-room-context';
import Filter from './filter';
import { ContainerMamageClass, ContentManageClass } from './manage-class-style';

export default function ManageClass() {
  const { colunas, handleValidDrop, fetchColumnsItem } =
    React.useContext(NewClassRoomContext);

  return (
    <ContainerMamageClass>
      <Filter />
      <ContentManageClass>
        <BaSeBoard
          itemListMaxWidth={600}
          itemListMinWidth={450}
          columns={colunas}
          onFetchColumnItem={fetchColumnsItem}
          validateDrop={handleValidDrop}
        />
      </ContentManageClass>
    </ContainerMamageClass>
  );
}
